import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { OptionsList } from '../../gung-select-option-input/gung-select-option-input.component';

const DEFAULT_TARGET_TYPE = 'String';

@Component({
    selector: 'lib-template-item-editor-modal',
    templateUrl: './template-item-editor-modal.component.html',
    styleUrls: ['./template-item-editor-modal.component.css'],
    standalone: false
})
export class TemplateItemEditorModalComponent {
  // @Input() item: any;
  @Input('item')
  set item(value) {
    const item = JSON.parse(value);
    this.submitForm.patchValue({ ...item, targetType: item.targetType || DEFAULT_TARGET_TYPE });
  }

  @Input() isActuator;
  @Input() 
  public cloneItem: boolean;

  submitForm: FormGroup;

  protected translateService = inject(TranslateService);

  targetTypeOptions: OptionsList[] = [
    { id: DEFAULT_TARGET_TYPE, name: this.translateService.instant('DEFAULT_TYPE') },
    { id: 'STRING', name: this.translateService.instant('STRING') },
    { id: 'NUMBER', name: this.translateService.instant('NUMBER') },
    { id: 'BOOLEAN', name: this.translateService.instant('BOOLEAN') },
    { id: 'IMAGE', name: this.translateService.instant('IMAGE') },
    { id: 'HYPERLINK', name: this.translateService.instant('HYPERLINK') }
  ];

  constructor(protected formBuilder: FormBuilder, public ngbActiveModal: NgbActiveModal) {
    this.setForm();
  }

  setForm() {
    this.submitForm = this.formBuilder.group({
      active: this.formBuilder.control(false),
      ignoreErrors: this.formBuilder.control(false),
      title: this.formBuilder.control(''),
      targetPath: this.formBuilder.control(''),
      targetType: this.formBuilder.control(DEFAULT_TARGET_TYPE),
      expression: this.formBuilder.control('')
    });
  }

  onSubmit() {
    if (!this.submitForm.valid) {
      this.submitForm.markAllAsTouched();
      return;
    }
    const item = this.submitForm.getRawValue();
    this.submitForm.reset();
    this.ngbActiveModal.close(JSON.stringify(item));
  }
}
